import WorkboardModelsTable from '../WorkboardModelsTable/WorkboardModelsTable';

const WorkboardModels = () => <WorkboardModelsTable filterType="current" />;

export default WorkboardModels;

